<template>
	<div class="childDiv2" id="page12" ref="mainEl" page="7">
		<img src="images/1x_images/section2/page7/complete-your-routine.png" srcset="images/2x_images/section2/page7/complete-your-routine.png 2x" class="img-bg" />

		<div class="childWrapper">
			<img alt="" src="images/1x_images/section2/page7/complete-your-routine-title.png" srcset="images/2x_images/section2/page7/complete-your-routine-title.png 2x" class="absolute center top-[160px]" />
			<div class="w-fit flex absolute center bottom-[80px] gap-[110px]">
				<img alt="" src="images/1x_images/section2/page7/complete-routine-step1.png" srcset="images/2x_images/section2/page7/complete-routine-step1.png 2x" class="button" @click="show(1)" />
				<img alt="" src="images/1x_images/section2/page7/complete-routine-step2.png" srcset="images/2x_images/section2/page7/complete-routine-step2.png 2x" class="button" @click="show(2)" />
				<img alt="" src="images/1x_images/section2/page7/complete-routine-step3.png" srcset="images/2x_images/section2/page7/complete-routine-step3.png 2x" class="button" @click="show(3)" />
			</div>
		</div>

		<!-- step 1 -->
		<div class="modal" ref="modal1El">
			<div class="childWrapper">
				<img alt="" class="button relative pt-[200px] center" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(1)" />
				<div class="relative w-full">
					<div class="relative flex flex-col gap-[20px]">
						<img alt="" src="images/1x_images/section2/page7/complete-routine-step1-text.png" srcset="images/2x_images/section2/page7/complete-routine-step1-text.png 2x" class="relative center" />
						<div class="w-full relative top-[-25px]">
							<Carousel :images="step1images" :top="-95" ref="carousel1El" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- step 2 -->
		<div class="modal" ref="modal2El">
			<div class="childWrapper">
				<img alt="" class="button relative pt-[200px] center" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(2)" />
				<div class="relative w-full">
					<div class="relative flex flex-col gap-[20px]">
						<img alt="" src="images/1x_images/section2/page7/complete-routine-step2-text.png" srcset="images/2x_images/section2/page7/complete-routine-step2-text.png 2x" class="relative center" />
						<div class="w-full relative top-[-25px]">
							<Carousel :images="step2images" :top="-95" ref="carousel2El" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- step 3 -->
		<div class="modal" ref="modal3El">
			<div class="childWrapper">
				<img alt="" class="button relative pt-[200px] center" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close(3)" />
				<div class="relative w-full">
					<div class="relative flex flex-col gap-[20px]">
						<img alt="" src="images/1x_images/section2/page7/complete-routine-step3-text.png" srcset="images/2x_images/section2/page7/complete-routine-step3-text.png 2x" class="relative center" />
						<div class="w-full relative top-[-25px]">
							<Carousel :images="step3images" :top="-95" ref="carousel3El" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import VideoComp from "../../components/Videos.vue";
import Carousel from "../../components/Carousel.vue";
import gsap from "gsap";

export default {
	name: "page-1",
	components: { VideoComp, Carousel },
	data() {
		return {
			tween: null,
			step1images: ["section2/page7/complete-routine-step1-img1.png"],
			step2images: ["section2/page7/complete-routine-step2-img1.png", "section2/page7/complete-routine-step2-img2.png"],
			step3images: ["section2/page7/complete-routine-step3-img1.png", "section2/page7/complete-routine-step3-img2.png"],
		};
	},
	methods: {
		start() {
			this.reset();
		},
		stop() {},
		show(type) {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page2-menu", { autoAlpha: 0 });
			gsap.set(this.$refs[`modal${type}El`], { autoAlpha: 1 });
		},
		close(type) {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page2-menu", { autoAlpha: 1 });
			gsap.set(this.$refs[`modal${type}El`], { autoAlpha: 0 });
			this.$refs[`carousel${type}El`].reset();
		},
		reset() {
			this.$refs[`carousel1El`].reset();
			this.$refs[`carousel2El`].reset();
			this.$refs[`carousel3El`].reset();
		},
	},
	mounted() {
		this.reset();
	},
};
</script>

<style></style>
